export default {
    'multiple-languages': {
        title: 'Version 2.3 : Keybreak parle sept langues',
        excerpt: 'La version 2.3 apporte la prise en charge multilingue, toute l\'application et le site sont désormais disponibles en sept langues, et d\'autres arrivent.',
    },
    'micro-breaks': {
        title: 'Version 2.2 : les micro-pauses',
        excerpt: 'Après quelques retours d\'utilisateurs, la version 2.2 ajoute les micro-pauses : un petit message dans le coin de ton écran toutes les 10–15 minutes, avec une seule chose à essayer.',
    },
    'dynamic-hold-system': {
        title: 'Version 2.1 : des maintiens plus malins et un meilleur retour visuel',
        excerpt: 'La version 2.1 ajoute deux choses : la possibilité d\'allonger le temps de maintien à la volée, et un nouveau système d\'animation qui te montre exactement où tu en es dans chaque maintien.',
    },
    'science-of-sitting': {
        title: 'La science de la sédentarité : ce que la recherche nous dit sur les journées passées assis',
        excerpt: 'La sédentarité est un facteur de risque à part entière, largement indépendant du fait que tu fasses du sport ou non. Voici ce que montre réellement la recherche.',
    },
    'benefits-of-moving': {
        title: 'Pourquoi bouger plus pendant ta journée de travail change vraiment quelque chose',
        excerpt: 'Les pauses actives régulières ne font pas que du bien à ton corps, elles te rendent plus vif, moins fatigué et plus productif sur l\'ensemble d\'une journée.',
    },
    'keybreak-launch': {
        title: 'Keybreak : voici ton compagnon de pause intelligent',
        excerpt: 'Après des mois de développement, nous sommes ravis d\'annoncer que Keybreak est officiellement disponible, en téléchargement gratuit sur Mac et Windows.',
    },
}
